export default {
  props: {
    id: { type: String, required: true },
    name: { type: String, required: true },
    label: { type: String, default: "" },
    field: { type: Object, required: true },
    messages: { type: Object, default: () => ({}) },
    showError: { type: Boolean, default: false }
  },
  computed: {
    canShowError() {
      return this.showError && this.field.$error && !!this.errorMessage;
    },
    errorMessage() {
      if (this.field.$params) {
        const message = Object.keys(this.field.$params).find(errorKey => {
          return this.field[errorKey] === false;
        });
        if (message && this.field.$params[message].type) {
          return this.messages[this.field.$params[message].type];
        }
      }
      return false;
    }
  }
};
